
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { EVENTS } from '../../bus/events.const';
import { logger } from '../../logger';

@Component
export default class DefaultOpen extends Vue {
  @Prop({ required: true })
  protected domTriggersSelector: string;

  @Prop({ default: 'click' })
  protected domTriggerEvent: string;

  @Prop({ default: true })
  protected delegateEvent: boolean;

  mounted() {
    this.$x.on(EVENTS.RebindDomEvents).subscribe(this.updateListeners);
  }

  @Watch('domTriggerEvent', { immediate: true })
  onDomTriggerEventChange() {
    this.updateListeners();
  }

  protected updateListeners(): void {
    const domTriggers = this.delegateEvent ? [document] : this.getDomTriggers();

    domTriggers.forEach(this.updateElementListener);
  }

  protected updateElementListener(element: Node): void {
    element.removeEventListener(this.domTriggerEvent, this.eventListener);
    element.addEventListener(this.domTriggerEvent, this.eventListener);
  }

  protected eventListener(event: Event): void {
    if (!this.delegateEvent || this.isDomTriggerTarget(event)) {
      event.preventDefault();
      this.onTriggerEvent();
    }
  }

  protected isDomTriggerTarget(event: Event): boolean {
    const domTriggers = this.getDomTriggers();
    const target =  event.target as HTMLElement;
    return domTriggers.some(domTrigger => target === domTrigger || domTrigger.contains(target));
  }

  protected getDomTriggers(): Node[] {
    const domTriggers = Array.from(document.querySelectorAll<HTMLElement>(this.domTriggersSelector));
    if (!domTriggers) {
      logger.warn('[DEFAULT_OPEN]', `the client open triggers are not found with selector: ${ this.domTriggersSelector }`);
    }
    return domTriggers;
  }

  protected onTriggerEvent() {
    this.$x.emit(EVENTS.OpenEmpathyX);
  }

  // Needed as this component doesn't have template
  render() {}
}
